// פרטי קשר ותצורה במקום אחד — עדכון כאן משתקף בכל האתר.
export const PHONE_DISPLAY = '053-2284404';
export const PHONE_TEL = '0532284404';
export const WHATSAPP_LINK = 'https://wa.me/972532284404';
export const EMAIL = 'office.dvir@gmail.com';
export const ADDRESS = 'אתרוג 28, גן יבנה';

// כתובת השרת (טפסים ומערכת ניהול)
export const API_URL = process.env.REACT_APP_API_URL || 'https://dvirhandasa-api.onrender.com';

// מזהה Google Analytics (מתחיל ב-G-). כשמכניסים אותו כאן — המעקב מופעל אוטומטית.
// איך משיגים אותו: ראו ANALYTICS-SETUP.md. עד שמכניסים ערך — המעקב פשוט כבוי.
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_ID || '';
